import { EOffersActions, INewbuildingsAction } from '../../actions/offersData';
import { prepareNewbuildings } from '../../mappers/prepareNewbuildings';
import { INewbuildingsState } from '../../types/newbuilding/newbuildingsState';

const defaultNewbuildings: INewbuildingsState = {
  allIds: [],
  byId: {},
  allSimilarNewbuildingsIds: [],
};

export function newbuildings(state: INewbuildingsState = defaultNewbuildings, action: INewbuildingsAction) {
  switch (action.type) {
    case EOffersActions.set:
      return prepareNewbuildings(action.data);
    case EOffersActions.setNewbuildingComparisonStatus: {
      const currentNewbuilding = state.byId[action.newbuildingId];

      if (!currentNewbuilding) {
        return state;
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [action.newbuildingId]: {
            ...currentNewbuilding,
            comparisonStatus: action.comparisonStatus,
          },
        },
      };
    }
    default:
      return { ...state };
  }
}
